module.exports = __webpack_public_path__ + "static/media/logoMDLINKS.176a5d68.svg";